import type { RouteObject } from "react-router-dom";
import NotFound from "@/pages/NotFound";
import Home from "@/pages/home/page";
import ServicePage from "@/pages/service/page";
import StrengthPage from "@/pages/strength/page";
import FlowPage from "@/pages/flow/page";
import FaqPage from "@/pages/faq/page";
import CompanyPage from "@/pages/company/page";
import DiagnosisPage from "@/pages/diagnosis/page";
import ContactPage from "@/pages/contact/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/service",
    element: <ServicePage />,
  },
  {
    path: "/strength",
    element: <StrengthPage />,
  },
  {
    path: "/flow",
    element: <FlowPage />,
  },
  {
    path: "/faq",
    element: <FaqPage />,
  },
  {
    path: "/company",
    element: <CompanyPage />,
  },
  {
    path: "/diagnosis",
    element: <DiagnosisPage />,
  },
  {
    path: "/contact",
    element: <ContactPage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
